<template>
  <Teleport to="body">
    <div
      class="pointer-events-none fixed inset-x-0 bottom-0"
    >
      <div class="flex justify-center p-8">
        <Transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-out"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <div
            v-if="isRevealed"
            role="alert"
            aria-live="assertive"
            class="pointer-events-auto relative flex max-w-lg items-center justify-center rounded-lg border border-error/10 bg-background p-4 shadow-md shadow-error/20"
          >
            <div>
              <div>
                <div class="mb-2 flex items-center">
                  <IconExclamationCircleFilled
                    class="mr-2 text-error"
                  />

                  <p class="text-lg font-medium">
                    Your account is inactive
                  </p>
                </div>

                <p class="text-sm leading-snug">
                  In order to reactivate your account either
                </p>
                <ul class="list-disc pl-4 text-sm">
                  <li>
                    Ask another user with access to your web
                    portal to activate you
                  </li>
                  <li>
                    Request a web portal login link using
                    your terminal app
                  </li>
                </ul>
              </div>
              <div class="flex w-full justify-end">
                <ButtonSecondary
                  variant="error"
                  @click="dismiss"
                >
                  Dismiss
                </ButtonSecondary>
              </div>
            </div>

            <div class="absolute right-0 top-0 p-2">
              <ButtonWithIcon
                type="button"
                @click="dismiss"
              >
                <IconX />
              </ButtonWithIcon>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (event: "dismiss"): void
}>()

const { reveal, isRevealed, cancel } = useConfirmDialog()

defineExpose({
  reveal,
})

const dismiss = cancel
</script>
